export function calculateTotalPrice (lineItem) {
    const { price } = lineItem;
    let basePrice = (price.manual === null)
        ? price.discounted
        : (price.manual || 0); // the manual price might be an empty string

    let total = (lineItem.quantity * basePrice);

    if (lineItem.price.discount && lineItem.price.discount.quantity > 0) {
        total -= lineItem.price.discount.total;
    }

    return total;
}

export function formatLocationAddress (locationAddress, customer, phone) {
    return locationAddress
        ? {
            firstName: locationAddress.first_name ?? customer.additional_data.first_name,
            lastName: locationAddress.last_name ?? customer.additional_data.last_name,
            company: locationAddress.address1,
            address1: locationAddress.address2,
            address2: locationAddress.address3,
            city: locationAddress.city,
            province: locationAddress.state,
            country: locationAddress.country,
            zip: locationAddress.zip_code,
            phone: phone
        }
        : null;
}

export function getDiscountDetails (lineItem) {
    const { price } = lineItem;

    // we have to round it, otherwise JS will do some weird stuff with it
    const totalDiscount = parseFloat(parseFloat(price.discount?.total ?? 0).toFixed(2));

    if (totalDiscount == 0) {
        const manual = parseFloat(price.manual);
        const discounted = parseFloat(price.discounted);
        const original = parseFloat(price.original);

        if (price.manual && manual > 0) {
            return {
                valueType: 'FIXED_AMOUNT',
                value: Number((original - manual).toFixed(2)),
            }
        }

        if (original > discounted) {
            return {
                valueType: 'FIXED_AMOUNT',
                value: Number((original - discounted).toFixed(2)),
            }
        }

        return null;
    }

    return {
        valueType: 'FIXED_AMOUNT',
        value: Number((totalDiscount / lineItem.quantity).toFixed(2)),
    };
}
